import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * The framed state strip shared by settings sections: a bordered, muted bar that holds a section's
 * loading / error / empty state so every section reads the same inside its {@link SettingsCard}.
 * Pass a trailing element (e.g. a spinner) as a second child — the strip spaces its children apart.
 */
export function StatusStrip({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      data-slot="status-strip"
      className={cn(
        'flex flex-wrap items-center justify-between gap-3 rounded-lg border bg-muted/40 px-3.5 py-2.5',
        className,
      )}
    >
      {children}
    </div>
  );
}
